import React, { forwardRef, useEffect, useState } from 'react';
import s from './ToolsContainer.module.css';
import CopyButton from '../tools-buttons/CopyButton';
import RetryButton from '../tools-buttons/RetryButton';
import ReactQuill from 'react-quill';
import CutButton from '../tools-buttons/CutButton';
import NoteButton from '../tools-buttons/NoteButton';
import EditButton from '../tools-buttons/EditButton';
import DownloadButton from '../tools-buttons/DownloadButton';
import ShareButton from '../tools-buttons/ShareButton';
import EditImageButton from '../tools-buttons/EditImageButton';
import DeleteButton from '../tools-buttons/DeleteButton';
import SaveChangesButton from '../tools-buttons/SaveChangesButton';
import EmojiButton from '../tools-buttons/EmojiButton';
type PageType = 'text' | 'image';
type ToolsContainerProps = {
    value?: string;
    isEditorFocused?: boolean;
    isImageFocused?: boolean;
    containerPosition?: { top: number; right: number } | null;
    quillRef?: React.RefObject<ReactQuill>;
    onCloseContext?: () => void;
    pageType: PageType;
    newImageWithEffects?: File | null;
    isShow?: boolean;
};

const ToolsContainer = forwardRef<HTMLDivElement, ToolsContainerProps>(
    (
        {
            value,
            isEditorFocused,
            isImageFocused,
            containerPosition,
            quillRef,
            onCloseContext,
            pageType,
            newImageWithEffects,
            isShow,
        },
        ref,
    ) => {
        const [activeTool, setActiveTool] = useState<string | null>(null);

        const handleSetActive = (toolName: string) => {
            setActiveTool((prev) => (prev === toolName ? null : toolName));
        };

        useEffect(() => {
            if (!isEditorFocused && !isImageFocused) {
                setActiveTool(null);
            }
        }, [isEditorFocused, isImageFocused]);

        if (!isEditorFocused && !isImageFocused) return null;

        const TOOL_HEIGHT = 300;

        let positionStyle: React.CSSProperties = {};

        if (pageType === 'text') {
            if (isEditorFocused) {
                positionStyle.top = 90;
            } else if (isImageFocused && containerPosition) {
                const spaceBelow = window.innerHeight - containerPosition.top;
                if (spaceBelow < TOOL_HEIGHT) {
                    positionStyle.bottom = 30;
                } else {
                    positionStyle.top = containerPosition.top;
                }
            }
        }

        return (
            <div ref={ref} className={s.container}>
                <div className={s.tools_container} style={positionStyle}>
                    {isEditorFocused && (
                        <>
                            <RetryButton
                                isActive={activeTool === 'retry'}
                                onClick={() => handleSetActive('retry')}
                                mode={'text'}
                            />
                            {quillRef && (
                                <CopyButton
                                    value={value || ''}
                                    quillRef={quillRef}
                                    isActive={activeTool === 'copy'}
                                    onClick={() => handleSetActive('copy')}
                                />
                            )}
                            {quillRef && (
                                <CutButton
                                    quillRef={quillRef}
                                    isActive={activeTool === 'cut'}
                                    onClick={() => handleSetActive('cut')}
                                />
                            )}

                            <NoteButton
                                isActive={activeTool === 'note'}
                                onClick={() => handleSetActive('note')}
                            />
                            {quillRef && (
                                <EmojiButton
                                    quillRef={quillRef}
                                    isActive={activeTool === 'emoji'}
                                    onClick={() => handleSetActive('emoji')}
                                />
                            )}
                        </>
                    )}

                    {isImageFocused && pageType === 'text' && isShow && (
                        <>
                            <RetryButton
                                isActive={activeTool === 'retry'}
                                onClick={() => handleSetActive('retry')}
                                mode={'image'}
                            />
                            <EditImageButton />
                            {/* <DownloadButton
                                isActive={activeTool === 'download'}
                                onClick={() => handleSetActive('download')}
                            /> */}
                            {/* <ShareButton
                                isActive={activeTool === 'share'}
                                onClick={() => handleSetActive('share')}
                            /> */}
                        </>
                    )}
                    {isImageFocused && pageType === 'image' && (
                        <>
                            <RetryButton
                                isActive={activeTool === 'retry'}
                                onClick={() => handleSetActive('retry')}
                                mode={'image'}
                            />

                            <DownloadButton
                                isActive={activeTool === 'download'}
                                onClick={() => handleSetActive('download')}
                            />
                            {/* <ShareButton
                                isActive={activeTool === 'share'}
                                onClick={() => handleSetActive('share')}
                            />
                             */}
                            <DeleteButton />
                            <SaveChangesButton newImageWithEffects={newImageWithEffects} />
                        </>
                    )}
                </div>
            </div>
        );
    },
);

export default ToolsContainer;
